import { Component, OnInit } from '@angular/core';
import { TranslationsService } from 'src/app/services/translations/translations.service';
import { AlertService } from 'src/app/services/alert.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CONSTANTS_METHODS_NOT_FOUND, CONSTANTS } from 'src/app/constants/users.constants'
import { TokenServiceService } from 'src/app/services/token-service.service';
import { Transaction } from 'src/app/models';
import { GENERAL_CONSTANTS } from 'src/app/core/constants/General-constants';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-methods-not-found-alert',
  templateUrl: './methods-not-found-alert.component.html',
  styleUrls: ['./methods-not-found-alert.component.scss'],
})
export class MethodsNotFoundAlertComponent implements OnInit {
  formNotMethods: FormGroup;
  constantsComponent = CONSTANTS_METHODS_NOT_FOUND;
  generalConstants = CONSTANTS;
  transactionInfo: Transaction;
  loading = false;
  termsConditionsUrl = environment.terms_conditions_url;
  policyDataUrl = environment.policy_data_url;
  limitsMessage: string;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly translationsService: TranslationsService,
    private readonly alertService: AlertService,
    private readonly tokenService: TokenServiceService
  ) {
    this.formNotMethods = this.formBuilder.group({
      email: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(GENERAL_CONSTANTS.PATTERN.EMAIL_VALIDATOR),
        ]),
      ],
      checkBoxTyc: ['', Validators.requiredTrue],
    });
  }

  ngOnInit(): void {
    this.transactionInfo = this.tokenService.getAndDecodeToken();
    this.translationsService.setCurrentCountry();
    if (Number(this.transactionInfo.ORDER_AMOUT) < 100000.00) {
      this.limitsMessage = "alert-bnpl-limits-below-allowed";
    } else if (Number(this.transactionInfo.ORDER_AMOUT) > 3000000.0) {
      this.limitsMessage = 'alert-bnpl-limits-above-allowed';
    }
  }
  /**
   *
   * @description {returnMethods} Function to return checkout pay-methods
   */
  returnMethods = () => {
    window.location.href = this.transactionInfo.MERCHANT_URL_RETURN;
    if (this.transactionInfo.ORDER_METHOD) {
      window.location.href = this.transactionInfo.MERCHANT_URL_RETURN;
      return;
    }
    location.reload();
  };
  /**
   *
   * @description {showAlertResponse} Function show info response
   */
  showAlertResponse = (statusCode: number) => {
    if (statusCode == 200) {
      this.alertService.showPopup(
        this.constantsComponent.RECEIVED_EMAIL_OK,
        this.constantsComponent.RECEIVED_EMAIL_DESC,
        'success',
        this.generalConstants.UNDERSTOOD
      );
      this.loading = false;
      return;
    }
    this.alertService.showAlert(
      this.generalConstants.GENERAL_ALERT,
      'warning',
      this.generalConstants.TITLE_ATTENTION
    );
    this.loading = false;
  };
}
